import { Switch } from './switch.component';
import type { BasicBoolFieldProps } from '../../layouts';
import { BoolFieldLayout } from '../../layouts';

export const SwitchField = (props: BasicBoolFieldProps<'switch'>) => {
  return <BoolFieldLayout {...props} field={Switch} />;
};
